export default __webpack_public_path__ + "static/media/bettadabyreweshwaratemple.aef231ff.jpg";